import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "detail-page"
};
const _hoisted_2 = {
  class: "left shadow-box"
};
const _hoisted_3 = {
  class: "footer-bar"
};
const _hoisted_4 = {
  class: "floor-wrap"
};
const _hoisted_5 = {
  class: "col-item"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "floor-wrap"
};
const _hoisted_8 = {
  class: "col-item",
  style: {
    "width": "100%"
  }
};
const _hoisted_9 = {
  class: "col-item"
};
const _hoisted_10 = {
  key: 0,
  class: "col-item"
};
const _hoisted_11 = {
  class: "col-item"
};
const _hoisted_12 = {
  class: "col-item"
};
const _hoisted_13 = {
  class: "col-item"
};
const _hoisted_14 = {
  class: "col-item"
};
const _hoisted_15 = {
  class: "title"
};
const _hoisted_16 = {
  class: "title"
};
const _hoisted_17 = {
  class: "biz-div"
};
const _hoisted_18 = {
  class: "floor-wrap"
};
const _hoisted_19 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_assets_biz = _resolveComponent("assets-biz");
  const _component_tag_modal = _resolveComponent("tag-modal");
  const _component_add_assets_product = _resolveComponent("add-assets-product");
  const _component_select_favorite = _resolveComponent("select-favorite");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _directive_has = _resolveDirective("has");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [!$setup.detail.favorite ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    size: "small",
    type: "default",
    icon: "el-icon-star-off",
    onClick: $setup.favHandler
  }, {
    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("收藏", -1)]))]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), $setup.detail.favorite ? (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    size: "small",
    type: "default",
    icon: "el-icon-star-on",
    onClick: $setup.favHandler
  }, {
    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("已收藏", -1)]))]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)]), _cache[21] || (_cache[21] = _createElementVNode("div", {
    class: "title"
  }, "短信内容", -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($setup.detail.content), 1)]), _createElementVNode("div", _hoisted_6, [_cache[9] || (_cache[9] = _createTextVNode("素材简介 ", -1)), _createVNode(_component_el_button, {
    type: "primary",
    size: "mini",
    style: {
      "margin-left": "12px"
    },
    onClick: $setup.editHandler
  }, {
    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("修改", -1)]))]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, "需求名称： " + _toDisplayString($setup.detail.needName), 1), _createElementVNode("div", _hoisted_9, "需求创建人： " + _toDisplayString($setup.detail.needUser), 1), $setup.detail.srcTyp ? (_openBlock(), _createElementBlock("div", _hoisted_10, "素材类型： " + _toDisplayString(_ctx.srcType[$setup.detail.srcTyp].typ), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_cache[12] || (_cache[12] = _createTextVNode(" 素材状态： ", -1)), $setup.detail.status === 1 ? (_openBlock(), _createBlock(_component_el_tag, {
    key: 0,
    type: "success",
    size: "mini",
    style: {
      "margin": "0 8px"
    }
  }, {
    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("在线", -1)]))]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_el_tag, {
    key: 1,
    type: "danger",
    size: "mini",
    style: {
      "margin": "0 8px"
    }
  }, {
    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("已下线", -1)]))]),
    _: 1
  }))]), _createElementVNode("div", _hoisted_12, "入库时间： " + _toDisplayString($setup.detail.createTime), 1), _createElementVNode("div", _hoisted_13, "素材有效期： " + _toDisplayString($setup.detail.bgnDate + " 至 " + $setup.detail.endDate), 1), _createElementVNode("div", _hoisted_14, "业务归属部门： " + _toDisplayString($setup.getBelongDepart($setup.detail.belongDepart)), 1)]), _createElementVNode("div", _hoisted_15, [_cache[16] || (_cache[16] = _createTextVNode("关联业务 ", -1)), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
    type: "primary",
    size: "mini",
    style: {
      "margin-left": "12px"
    },
    onClick: $setup.addAsProduct
  }, {
    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("添加", -1)]))]),
    _: 1
  }, 8, ["onClick"])), [[_directive_has, 'asset:lib:detail:product']]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
    type: "primary",
    size: "mini",
    style: {
      "margin-left": "12px"
    },
    onClick: $setup.downloadAssetProductModel
  }, {
    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("下载模板", -1)]))]),
    _: 1
  }, 8, ["onClick"])), [[_directive_has, 'asset:lib:detail-sms:product']]), _createVNode(_component_el_upload, {
    style: {
      "margin-left": "12px"
    },
    ref: "upload",
    action: "",
    "http-request": $setup.fileUpload,
    "show-file-list": false,
    "auto-upload": true
  }, {
    default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
      size: "mini",
      type: "primary"
    }, {
      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("批量导入", -1)]))]),
      _: 1
    })), [[_directive_has, 'asset:lib:detail-sms:product']])]),
    _: 1
  }, 8, ["http-request"])]), _createElementVNode("div", _hoisted_16, [_cache[17] || (_cache[17] = _createTextVNode("关联offerId ", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.detail.offerIds ? $setup.detail.offerIds.split(',') : [], offerId => {
    return _openBlock(), _createBlock(_component_el_tag, {
      key: offerId,
      class: "mx-1",
      "disable-transitions": false
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(offerId), 1)]),
      _: 2
    }, 1024);
  }), 128))]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_assets_biz, {
    id: $props.id,
    ref: "assetsBizRef"
  }, null, 8, ["id"])]), _createElementVNode("div", null, [_cache[20] || (_cache[20] = _createElementVNode("div", {
    class: "title"
  }, "附件", -1)), _createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (att, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "att-item"
    }, [_cache[19] || (_cache[19] = _createElementVNode("span", {
      class: "el-icon-document"
    }, null, -1)), _createTextVNode(" " + _toDisplayString(att.fileName) + " ", 1), _createVNode(_component_el_button, {
      link: "",
      onClick: $event => $setup.singleDownload(att.fileId, att.fileName)
    }, {
      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("下载", -1)]))]),
      _: 1
    }, 8, ["onClick"])]);
  }), 128))])])])]), _createVNode(_component_tag_modal, {
    modelValue: $setup.tagModalShow,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.tagModalShow = $event),
    onChooseHandler: $setup.addTagHandler
  }, null, 8, ["modelValue", "onChooseHandler"]), _createVNode(_component_add_assets_product, {
    ref: "addAsProdc",
    assetId: $props.id,
    onOk: $setup.addAsProdcOk
  }, null, 8, ["assetId", "onOk"]), _createVNode(_component_select_favorite, {
    ref: "selectFavoriteRef",
    choseAsset: _ctx.choseAsset,
    onOk: $setup.favorited
  }, null, 8, ["choseAsset", "onOk"]), _createVNode(_component_el_dialog, {
    title: "编辑",
    modelValue: _ctx.editShow,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.editShow = $event),
    width: "500px"
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_19, [_createVNode(_component_el_button, {
      onClick: _cache[4] || (_cache[4] = $event => _ctx.editShow = false)
    }, {
      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode("取 消", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $setup.confirmEdit
    }, {
      default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode("确 定", -1)]))]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      "label-width": "100px",
      size: "small"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "生效时间"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_date_picker, {
          modelValue: _ctx.date,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.date = $event),
          type: "daterange",
          "range-separator": "至",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "素材状态"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: _ctx.status,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.status = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: 1
          }, {
            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("上线", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: 0
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("下线", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "备注"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.remark,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.remark = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_add_assets_product, {
    ref: "addAsProdc",
    assetId: $props.id,
    onOk: $setup.addAsProdcOk
  }, null, 8, ["assetId", "onOk"])], 64);
}